module.exports = __webpack_public_path__ + "static/22-dba9e394969b55fe8c0e0c408275aa54.gif";